// extracted by mini-css-extract-plugin
export default {"confirmSection":"SystemErrorMessage_confirmSection__lCLxA","errorIcon":"SystemErrorMessage_errorIcon__60e4J","confirmBold":"SystemErrorMessage_confirmBold__kkaHx"};